<div class="content">
  {{ whiteboard | json }}
</div>
